import * as React from "react";
import { singleton } from "logic/singleton";
const TableFilterContext = React.createContext(void 0);
export default singleton("contexts.TableFilterContext", () => TableFilterContext);
